import { render, staticRenderFns } from "./OrganizationsListPage.vue?vue&type=template&id=14f5d756&scoped=true&"
import script from "./OrganizationsListPage.vue?vue&type=script&lang=ts&"
export * from "./OrganizationsListPage.vue?vue&type=script&lang=ts&"
import style0 from "./OrganizationsListPage.vue?vue&type=style&index=0&id=14f5d756&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "14f5d756",
  null
  
)

export default component.exports